import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { DarkOne, lastOne, LightDark, Lightight, smallLighterText } from "../../Assets/CSS/Text";
import { Ctnbtn } from "../../Assets/CSS/Button";
import toast from "react-hot-toast";
import axios from "axios";

const SalaryStructure = ({ empData, setActiveTab, setSalaryCompleted }) => {
    const [loading, setLoading] = useState(false);
    const [salaryData, setSalaryData] = useState(null);
    const [ctcAmount, setCtcAmount] = useState("");
    const [generateType, setGenerateType] = useState("auto"); // "auto" or "manual"
    // const [components, setComponents] = useState([]);
    const employeeId = empData.potentialEmployeeId;

    const [manual, setManual] = useState({
        ctcAmount: '',
        joiningDate: '',
        basic: '',
        lta: '',
        hra: '',
        conveyance: '',
        medical: '',
        otherDeduction: '',
        otherReimbursement: '',
        pfEmployee: '',
        pfEmployer: '',
        tds: '',
        specialAllowance: '',
        esic: '',
        empId: null
    });

    {/*}

    useEffect(() => {
        if (!employeeId) return;

        const fetchSalaryData = async () => {
            try {
                setLoading(true);
                const token = localStorage.getItem("token");

                const res = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/v1/potential-employees/${employeeId}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                setSalaryData(res.data);

                if (res.data?.ctcOfEmployee) {
                    setCtcAmount(res.data.ctcOfEmployee);
                    setSalaryCompleted(true);
                }
            }
            catch (err) {
                // ✅ NO SALARY YET → normal case
                if (err.response?.status === 404 || err.response?.status === 400) {
                    setSalaryData(null);   // allow CREATE
                    return;
                }

                // ❌ REAL error
                // toast.error("Failed to load employee data");
            }
            finally {
                setLoading(false);
            }
        };

        fetchSalaryData();
    }, [employeeId]);

    */}

    {/*}
    useEffect(() => {
        if (!employeeId) return;

        const fetchSalaryData = async () => {
            try {
                setLoading(true);
                const token = localStorage.getItem("token");

                const res = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/v1/potential-employees/${employeeId}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                setSalaryData(res.data);

                if (res.data?.ctcOfEmployee) {
                    setCtcAmount(res.data.ctcOfEmployee);
                    setSalaryCompleted(true);

                    // Populate manual form with existing data
                    if (res.data?.salaryComponents) {
                        const components = res.data.salaryComponents;
                        setManual({
                            ctcAmount: res.data.ctcOfEmployee || '',
                            joiningDate: res.data.dateOfJoining || '',
                            basic: components.BASIC || '',
                            lta: components.LTA || '',
                            hra: components.HRA || '',
                            conveyance: components.CONVEYANCE || '',
                            medical: components.MEDICAL || '',
                            otherDeduction: components.OTHER_DEDUCTION || '',
                            otherReimbursement: components.OTHER_REIMBURSEMENTS || '',
                            pfEmployee: components.PF_EMPLOYEE || '',
                            pfEmployer: components.PF_EMPLOYER || '',
                            tds: components.TDS || '',
                            specialAllowance: components.SPECIAL_ALLOWANCE || '',
                            esic: components.ESIC || '',
                            empId: res.data.empId || null
                        });
                    }
                }
            }
            catch (err) {
                // ✅ NO SALARY YET → normal case
                if (err.response?.status === 404 || err.response?.status === 400) {
                    setSalaryData(null);   // allow CREATE
                    return;
                }
                // ❌ REAL error
                // toast.error("Failed to load employee data");
            }
            finally {
                setLoading(false);
            }
        };

        fetchSalaryData();
    }, [employeeId]);
    */}

    useEffect(() => {
        if (!employeeId) return;

        const fetchSalaryData = async () => {
            try {
                setLoading(true);
                const token = localStorage.getItem("token");

                const res = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/v1/potential-employees/${employeeId}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                setSalaryData(res.data);

                if (res.data?.ctcOfEmployee) {
                    setCtcAmount(res.data.ctcOfEmployee);
                    setSalaryCompleted(true);

                    // Populate manual form with existing data
                    if (res.data?.salaryComponents) {
                        const components = res.data.salaryComponents;
                        setManual({
                            ctcAmount: res.data.ctcOfEmployee || '',
                            joiningDate: res.data.dateOfJoining || '',
                            basic: components.BASIC !== undefined ? components.BASIC : '',
                            lta: components.LTA !== undefined ? components.LTA : '',
                            hra: components.HRA !== undefined ? components.HRA : '',
                            conveyance: components.CONVEYANCE !== undefined ? components.CONVEYANCE : '',
                            medical: components.MEDICAL !== undefined ? components.MEDICAL : '',
                            otherDeduction: components.OTHER_DEDUCTION !== undefined ? components.OTHER_DEDUCTION : '',
                            otherReimbursement: components.OTHER_REIMBURSEMENTS !== undefined ? components.OTHER_REIMBURSEMENTS : '',
                            pfEmployee: components.PF_EMPLOYEE !== undefined ? components.PF_EMPLOYEE : '',
                            pfEmployer: components.PF_EMPLOYER !== undefined ? components.PF_EMPLOYER : '',
                            tds: components.TDS !== undefined ? components.TDS : '',
                            specialAllowance: components.SPECIAL_ALLOWANCE !== undefined ? components.SPECIAL_ALLOWANCE : '',
                            esic: components.ESIC !== undefined ? components.ESIC : '',
                            empId: res.data.empId || null
                        });
                    }
                }
            }
            catch (err) {
                // ✅ NO SALARY YET → normal case
                if (err.response?.status === 404 || err.response?.status === 400) {
                    setSalaryData(null);   // allow CREATE
                    return;
                }
                // ❌ REAL error
                // toast.error("Failed to load employee data");
            }
            finally {
                setLoading(false);
            }
        };

        fetchSalaryData();
    }, [employeeId]);

    const handleManualChange = (e) => {
        const { name, value } = e.target;
        setManual(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async () => {
        try {
            if (generateType === "auto") {
                // Auto Generate Logic
                if (!ctcAmount || Number(ctcAmount) <= 0) {
                    toast.error("Please enter CTC amount");
                    return;
                }
                setLoading(true);
                const token = localStorage.getItem("token");

                const payload = {
                    employeeId,
                    ctcAmount: Number(ctcAmount),
                };

                await axios.post(
                    `${process.env.REACT_APP_BACKEND_URL}/api/v1/salary/assign`,
                    payload,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                setSalaryCompleted(true);
                setActiveTab("letter");
                toast.success("Salary assigned successfully");
            } else {
                // Manual Generate Logic
                // Validate required fields
                if (!manual.ctcAmount || Number(manual.ctcAmount) <= 0) {
                    toast.error("Please enter CTC amount");
                    return;
                }
                if (!manual.joiningDate) {
                    toast.error("Please enter joining date");
                    return;
                }

                setLoading(true);
                const token = localStorage.getItem("token");

                const payload = {
                    employeeId,
                    ...manual,
                    empId: manual.empId,
                    ctcAmount: Number(manual.ctcAmount),
                    basic: Number(manual.basic) || 0,
                    lta: Number(manual.lta) || 0,
                    hra: Number(manual.hra) || 0,
                    conveyance: Number(manual.conveyance) || 0,
                    medical: Number(manual.medical) || 0,
                    otherDeduction: Number(manual.otherDeduction) || 0,
                    otherReimbursement: Number(manual.otherReimbursement) || 0,
                    pfEmployee: Number(manual.pfEmployee) || 0,
                    pfEmployer: Number(manual.pfEmployer) || 0,
                    tds: Number(manual.tds) || 0,
                    specialAllowance: Number(manual.specialAllowance) || 0,
                    esic: Number(manual.esic) || 0
                };

                await axios.post(
                    `${process.env.REACT_APP_BACKEND_URL}/api/v1/salary/assign-manually`,
                    payload,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                setSalaryCompleted(true);
                setActiveTab("letter");
                toast.success("Salary assigned successfully");
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Submission failed");
        } finally {
            setLoading(false);
        }
    };

    const handleUpdate = async () => {
        try {
            if (generateType === "auto") {
                // Auto Generate Logic
                if (!ctcAmount || Number(ctcAmount) <= 0) {
                    toast.error("Please enter CTC amount");
                    return;
                }
                setLoading(true);
                const token = localStorage.getItem("token");

                const payload = {
                    employeeId,
                    ctcAmount: Number(ctcAmount),
                };

                await axios.patch(
                    `${process.env.REACT_APP_BACKEND_URL}/api/v1/salary/assign`,
                    payload,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                setSalaryCompleted(true);
                setActiveTab("letter");
                toast.success("Salary assigned successfully");
            } else {
                // Manual Generate Logic
                // Validate required fields
                if (!manual.ctcAmount || Number(manual.ctcAmount) <= 0) {
                    toast.error("Please enter CTC amount");
                    return;
                }
                if (!manual.joiningDate) {
                    toast.error("Please enter joining date");
                    return;
                }

                setLoading(true);
                const token = localStorage.getItem("token");

                const payload = {
                    employeeId,
                    ...manual,
                    empId: manual.empId,
                    ctcAmount: Number(manual.ctcAmount),
                    basic: Number(manual.basic) || 0,
                    lta: Number(manual.lta) || 0,
                    hra: Number(manual.hra) || 0,
                    conveyance: Number(manual.conveyance) || 0,
                    medical: Number(manual.medical) || 0,
                    otherDeduction: Number(manual.otherDeduction) || 0,
                    otherReimbursement: Number(manual.otherReimbursement) || 0,
                    pfEmployee: Number(manual.pfEmployee) || 0,
                    pfEmployer: Number(manual.pfEmployer) || 0,
                    tds: Number(manual.tds) || 0,
                    specialAllowance: Number(manual.specialAllowance) || 0,
                    esic: Number(manual.esic) || 0
                };

                await axios.patch(
                    `${process.env.REACT_APP_BACKEND_URL}/api/v1/salary/assign-manually`,
                    payload,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                setSalaryCompleted(true);
                setActiveTab("letter");
                toast.success("Salary assigned successfully");
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Submission failed");
        } finally {
            setLoading(false);
        }
    };

    const isSalaryAssigned = Boolean(
        salaryData?.ctcOfEmployee &&
        Object.keys(salaryData?.salaryComponents || {}).length > 0
    );

    return (
        <div className="container py-0" style={{ maxWidth: "900px" }}>
            <p style={Lightight}>Generate offer letter with salary structure and annexures</p>

            <h5 className="mb-4" style={lastOne}>Salary Breakdown</h5>

            {/* Toggle Buttons */}
            <div className="mb-4 d-flex gap-2">
                <button
                    className={`btn ${generateType === "auto" ? "btn-primary" : "btn-outline-secondary"}`}
                    onClick={() => setGenerateType("auto")}
                    style={{ borderRadius: "8px", padding: "8px 24px" }}
                >
                    Auto Generate
                </button>
                <button
                    className={`btn ${generateType === "manual" ? "btn-primary" : "btn-outline-secondary"}`}
                    onClick={() => setGenerateType("manual")}
                    style={{ borderRadius: "8px", padding: "8px 24px" }}
                >
                    Manual Generate
                </button>
            </div>

            {generateType === "auto" ? (
                // Auto Generate Form
                <div className="row g-3">
                    <div className="col-md-6 mb-4">
                        <label className="form-label d-flex justify-content-between">
                            <span style={LightDark}>CTC</span>
                            <small style={smallLighterText}>Annual</small>
                        </label>

                        <div className="d-flex gap-2">
                            <input
                                type="number"
                                className="form-control"
                                style={{
                                    textAlign: "right",
                                    borderRadius: "8px",
                                    height: "52px",
                                    fontWeight: "600",
                                    backgroundColor: "#F9FAFB"
                                }}
                                value={ctcAmount}
                                onChange={(e) => setCtcAmount(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="d-flex gap-3">
                        {salaryData?.ctcOfEmployee ? (
                            <button
                                className="px-4 continue-btn"
                                style={Ctnbtn}
                                onClick={handleUpdate}
                                disabled={loading}
                            >
                                {loading ? "Updating..." : "Update Breakdown"}
                            </button>
                        ) : (
                            <button
                                className="px-4 continue-btn"
                                style={Ctnbtn}
                                onClick={handleSubmit}
                                disabled={loading}
                            >
                                {loading ? "Loading..." : "Breakdown"}
                            </button>
                        )}
                    </div>
                </div>
            ) : (
                // Manual Generate Form
                <div className="row g-3">
                    <div className="col-md-6">
                        <label className="form-label">
                            <span style={LightDark}>CTC Amount *</span>
                        </label>
                        <input
                            type="number"
                            name="ctcAmount"
                            className="form-control"
                            style={{
                                borderRadius: "8px",
                                height: "42px",
                                backgroundColor: "#F9FAFB"
                            }}
                            value={manual.ctcAmount}
                            onChange={handleManualChange}
                            placeholder="Enter CTC amount"
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">
                            <span style={LightDark}>Joining Date *</span>
                        </label>
                        <input
                            type="date"
                            name="joiningDate"
                            className="form-control"
                            style={{
                                borderRadius: "8px",
                                height: "42px",
                                backgroundColor: "#F9FAFB"
                            }}
                            value={manual.joiningDate}
                            onChange={handleManualChange}
                        />
                    </div>

                    {/* ADD THIS NEW FIELD */}
                    <div className="col-md-6">
                        <label className="form-label">
                            <span style={LightDark}>Employee ID</span>
                        </label>
                        <input
                            type="text"
                            name="empId"
                            className="form-control"
                            style={{
                                borderRadius: "8px",
                                height: "42px",
                                backgroundColor: "#F9FAFB"
                            }}
                            value={manual.empId}
                            onChange={handleManualChange}
                            placeholder="Enter Employee ID"
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">
                            <span style={LightDark}>Basic</span>
                        </label>
                        <input
                            type="number"
                            name="basic"
                            className="form-control"
                            style={{
                                borderRadius: "8px",
                                height: "42px",
                                backgroundColor: "#F9FAFB"
                            }}
                            value={manual.basic}
                            onChange={handleManualChange}
                            placeholder="Enter basic"
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">
                            <span style={LightDark}>HRA</span>
                        </label>
                        <input
                            type="number"
                            name="hra"
                            className="form-control"
                            style={{
                                borderRadius: "8px",
                                height: "42px",
                                backgroundColor: "#F9FAFB"
                            }}
                            value={manual.hra}
                            onChange={handleManualChange}
                            placeholder="Enter HRA"
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">
                            <span style={LightDark}>LTA</span>
                        </label>
                        <input
                            type="number"
                            name="lta"
                            className="form-control"
                            style={{
                                borderRadius: "8px",
                                height: "42px",
                                backgroundColor: "#F9FAFB"
                            }}
                            value={manual.lta}
                            onChange={handleManualChange}
                            placeholder="Enter LTA"
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">
                            <span style={LightDark}>Conveyance</span>
                        </label>
                        <input
                            type="number"
                            name="conveyance"
                            className="form-control"
                            style={{
                                borderRadius: "8px",
                                height: "42px",
                                backgroundColor: "#F9FAFB"
                            }}
                            value={manual.conveyance}
                            onChange={handleManualChange}
                            placeholder="Enter conveyance"
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">
                            <span style={LightDark}>Medical</span>
                        </label>
                        <input
                            type="number"
                            name="medical"
                            className="form-control"
                            style={{
                                borderRadius: "8px",
                                height: "42px",
                                backgroundColor: "#F9FAFB"
                            }}
                            value={manual.medical}
                            onChange={handleManualChange}
                            placeholder="Enter medical"
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">
                            <span style={LightDark}>Special Allowance</span>
                        </label>
                        <input
                            type="number"
                            name="specialAllowance"
                            className="form-control"
                            style={{
                                borderRadius: "8px",
                                height: "42px",
                                backgroundColor: "#F9FAFB"
                            }}
                            value={manual.specialAllowance}
                            onChange={handleManualChange}
                            placeholder="Enter special allowance"
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">
                            <span style={LightDark}>Other Reimbursement</span>
                        </label>
                        <input
                            type="number"
                            name="otherReimbursement"
                            className="form-control"
                            style={{
                                borderRadius: "8px",
                                height: "42px",
                                backgroundColor: "#F9FAFB"
                            }}
                            value={manual.otherReimbursement}
                            onChange={handleManualChange}
                            placeholder="Enter other reimbursement"
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">
                            <span style={LightDark}>PF Employee</span>
                        </label>
                        <input
                            type="number"
                            name="pfEmployee"
                            className="form-control"
                            style={{
                                borderRadius: "8px",
                                height: "42px",
                                backgroundColor: "#F9FAFB"
                            }}
                            value={manual.pfEmployee}
                            onChange={handleManualChange}
                            placeholder="Enter PF employee"
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">
                            <span style={LightDark}>PF Employer</span>
                        </label>
                        <input
                            type="number"
                            name="pfEmployer"
                            className="form-control"
                            style={{
                                borderRadius: "8px",
                                height: "42px",
                                backgroundColor: "#F9FAFB"
                            }}
                            value={manual.pfEmployer}
                            onChange={handleManualChange}
                            placeholder="Enter PF employer"
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">
                            <span style={LightDark}>TDS</span>
                        </label>
                        <input
                            type="number"
                            name="tds"
                            className="form-control"
                            style={{
                                borderRadius: "8px",
                                height: "42px",
                                backgroundColor: "#F9FAFB"
                            }}
                            value={manual.tds}
                            onChange={handleManualChange}
                            placeholder="Enter TDS"
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">
                            <span style={LightDark}>ECIS</span>
                        </label>
                        <input
                            type="number"
                            name="esic"
                            className="form-control"
                            style={{
                                borderRadius: "8px",
                                height: "42px",
                                backgroundColor: "#F9FAFB"
                            }}
                            value={manual.esic}
                            onChange={handleManualChange}
                            placeholder="Enter ECIS"
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">
                            <span style={LightDark}>Other Deduction</span>
                        </label>
                        <input
                            type="number"
                            name="otherDeduction"
                            className="form-control"
                            style={{
                                borderRadius: "8px",
                                height: "42px",
                                backgroundColor: "#F9FAFB"
                            }}
                            value={manual.otherDeduction}
                            onChange={handleManualChange}
                            placeholder="Enter other deduction"
                        />
                    </div>

                    <div className="col-12 mt-4 d-flex gap-3">
                        {salaryData?.salaryComponents ? (
                            <button
                                className="px-4 continue-btn"
                                style={Ctnbtn}
                                onClick={handleUpdate}
                                disabled={loading}
                            >
                                {loading ? "Updating..." : "Update Manual Salary"}
                            </button>
                        ) : (
                            <button
                                className="px-4 continue-btn"
                                style={Ctnbtn}
                                onClick={handleSubmit}
                                disabled={loading}
                            >
                                {loading ? "Submitting..." : "Submit Manual Salary"}
                            </button>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default SalaryStructure;